import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import DialogFindGroupId from "../DialogFindGroupId";
// import DialogEdit from "./DialogEdit";
import {
  IconButton,
  Button
} from "@material-ui/core";


const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonAdd({ product, reloadData}) {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOnOpen = () => {
    setIsDialogOpen(true);
  };
  const handleOnClose = () => {
    setIsDialogOpen(false);
  }; 
 
  return (
    <>
      <Button  variant="contained" startIcon={<AddIcon />} onClick={handleOnOpen}>
        Add Competitor/Similar Product
      </Button>
       
      <DialogFindGroupId
        //fullScreen
        open={isDialogOpen}
        onClose={handleOnClose}
        product={product}
        reloadData={reloadData}
        isCompetitor={true}
      />      
    </>
  );
}
